// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Web component for default product card.
 * @author James Reid
 */

// @ts-check

// @@imports-utils
import { StyledComponent } from "../../base/index.js" 
import { Bom } from "../../../../../package/index.js"
import { getDefaultBreakdown } from "../../../layouts/bill-of-materials/cards/breakdowns/default.js"

// @@body
class ProductCard extends StyledComponent {
    constructor() {
        super({ templateId: "product-card" })
    }

    connectedCallback() {
        /** @type {HTMLSpanElement} */ (this.shadowRoot.querySelector("span.price"))
            .innerText = this.bom.price.toFixed(2)
        // /** @type {HTMLSpanElement} */ (this.querySelector("span.price"))
        //     .innerText = this.bom.price.toFixed(2)

        this.template?.querySelector("tbody")?.replaceWith(getDefaultBreakdown(this.bom))
        // this.querySelector("tbody")?.replaceWith(getDefaultBreakdown(this.bom))

        const image = document.createElement("img")
        image.src = this.bom.lineItems[0].product.imageUrl
        this.template?.querySelector("div.horizontal-container")?.append(image)
    }

    static get customName() {
        return "product-card"
    }
}

// @@exports
export { ProductCard }
